import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQueryClient, useMutation } from 'react-query';

function useReorderCategory() {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function reorderCategory(data) {
    return privateFetch.put('/v1/admin/podcast/categories/reorder', data);
  }

  return useMutation(reorderCategory, {
    onSuccess() {},
    onError(error) {
      console.error('Failed to reorder categories:', error);
    },
    onSettled() {
      queryClient.invalidateQueries('podcast-category');
      queryClient.invalidateQueries('podcast-reorder-category');
    },
  });
}

export default useReorderCategory;
